import { Controller } from "react-hook-form";

const MaskedInputField = ({
  label,
  name,
  id,
  error,
  control,
  customClassName,
  MaskComponent,
}: {
  label?: string;
  name: string;
  id?: string;
  error?: string;
  control: any;
  customClassName?: string;
  MaskComponent: any;
}) => {
  return (
    <div className={`${customClassName}`}>
      <label
        className={`leading-7 block text-sm font-medium text-neutralColor-medium`}
        htmlFor={id}
      >
        {label}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => <MaskComponent field={field} />}
      />
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
};
export default MaskedInputField;
